var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenubarHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    stroke: "white",
    strokeWidth: 1.5,
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.796 4.13612C12.8136 3.1215 11.1863 3.1215 10.2039 4.13611L5.40546 9.09185C5.12987 9.37646 4.94469 9.73627 4.87323 10.1259C4.29047 13.3039 4.24745 16.5574 4.74599 19.7496L4.92249 20.8798C4.97824 21.2368 5.2857 21.5 5.64701 21.5H8.99997C9.27611 21.5 9.49997 21.2761 9.49997 21V14H14.5V21C14.5 21.2761 14.7238 21.5 15 21.5H18.3529C18.7142 21.5 19.0217 21.2368 19.0774 20.8798L19.2539 19.7496C19.7524 16.5574 19.7094 13.3039 19.1267 10.1259C19.0552 9.73627 18.87 9.37646 18.5944 9.09185L13.796 4.13612Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenubarHome);
export default __webpack_public_path__ + "static/media/Menubar_home.db1005f92eef55b6d2e424e0298f9dd9.svg";
export { ForwardRef as ReactComponent };